import {
  CheckCircleFilled,
  DollarOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Row, Typography, Divider, Statistic } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const { Title, Text } = Typography;

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // Grab each param (or fall back to a default)
  const amountParam = params.get("amount") || "0.00";
  const dateParam = params.get("payment_date") || "";
  const companyParam = params.get("companyname") || "—";
  const transactionIdParam = params.get("trans_id") || "—";
  const planParam = params.get("plan") || "—";

  // Format the date string nicely, if present
  const formattedDate = dateParam ? new Date(dateParam).toLocaleString() : "—";

  const transactionDetails = {
    amount: amountParam,
    currency: "ZMW",
    plan: planParam,
    date: formattedDate,
    transactionId: transactionIdParam,
    company: companyParam,
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "40px 15px",
      }}
    >
      <Col xs={24} sm={22} md={20} lg={18} xl={14}>
        <Card
          hoverable
          style={{
            borderRadius: 12,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            background: "rgba(255, 255, 255, 0.96)",
          }}
          bodyStyle={{ padding: "40px 32px" }}
        >
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <CheckCircleFilled
              style={{
                fontSize: 72,
                color: "#52c41a",
                marginBottom: 24,
              }}
            />
            <Title level={2} style={{ marginBottom: 8, color: "#2D3748" }}>
              Payment Successful!
            </Title>
            <Text type="secondary" style={{ fontSize: 16 }}>
              Your KwachaPlus subscription has been activated
            </Text>
          </div>

          <Divider style={{ margin: "24px 0" }} />

          <Row gutter={24} style={{ marginBottom: 32 }}>
            <Col xs={24} md={12}>
              <Statistic
                title="Amount Paid"
                value={`${transactionDetails.currency} ${transactionDetails.amount}`}
                prefix={<DollarOutlined />}
                valueStyle={{ color: "#237804", fontSize: 24 }}
              />
            </Col>
            <Col xs={24} md={12}>
              <Statistic
                title="Plan Activated"
                value={transactionDetails.plan}
                prefix={<FileDoneOutlined />}
                valueStyle={{ fontSize: 18 }}
              />
            </Col>
          </Row>

          <div
            style={{
              background: "#f8f9fa",
              borderRadius: 8,
              padding: 16,
              marginBottom: 32,
            }}
          >
            <Text strong style={{ display: "block", marginBottom: 8 }}>
              Transaction Details:
            </Text>
            <Row gutter={[16, 8]}>
              <Col span={12}>
                <Text type="secondary">Date & Time:</Text>
                <Text strong style={{ display: "block" }}>
                  {transactionDetails.date}
                </Text>
              </Col>
              <Col span={12}>
                <Text type="secondary">Transaction ID:</Text>
                <Text code>{transactionDetails.transactionId}</Text>
              </Col>
              <Col span={24}>
                <Text type="secondary">Company:</Text>
                <Text strong style={{ display: "block" }}>
                  {transactionDetails.company}
                </Text>
              </Col>
            </Row>
          </div>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Button
                type="primary"
                block
                size="large"
                onClick={() => navigate("/login")}
                style={{
                  background:
                    "linear-gradient(135deg, #1890ff 0%, #0050b3 100%)",
                  border: "none",
                  height: 48,
                  borderRadius: 8,
                }}
              >
                Go to Dashboard
              </Button>
            </Col>
            <Col xs={24} md={12}>
              <Button
                block
                size="large"
                onClick={() => navigate("/login")}
                style={{
                  height: 48,
                  borderRadius: 8,
                }}
              >
                Return Home
              </Button>
            </Col>
          </Row>

          <Divider style={{ margin: "24px 0" }} />

          <div style={{ textAlign: "center" }}>
            <Text type="secondary" style={{ fontSize: 14 }}>
              Need assistance? Contact our support team at{" "}
              <a
                href="mailto:support@kwachaplus.com"
                style={{ color: "#667eea" }}
              >
                support@kwachaplus.com
              </a>
            </Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default PaymentSuccess;
